import { Instagram } from "lucide-react";
import { EncabezadoSeccion, Reveal } from "../../shared/motion";

export default function Menciones({ datos, seccion }) {
  const menciones = datos.menciones || [];
  if (menciones.length === 0) return null;

  return (
    <section className="qn-seccion" aria-label={seccion.titulo}>
      <div className="qn-seccion-interior">
        <EncabezadoSeccion p="qn" etiqueta={seccion.etiqueta} titulo={seccion.titulo} testid="qn-titulo-menciones" />
        <div className="qn-menciones">
          {menciones.map((m, i) => (
            <Reveal key={i} delay={i * 0.07}>
              <figure className="qn-mencion" data-testid={`qn-mencion-${i}`}>
                <span className="qn-mencion-marco">
                  <img className="qn-mencion-foto" src={m.foto} alt={`Fotografía de ${m.nombre}`} loading="lazy" />
                </span>
                <figcaption>
                  <p className="qn-mencion-nombre">{m.nombre}</p>
                  <p className="qn-mencion-rol">{m.rol}</p>
                  {m.instagramUrl && (
                    <a
                      className="qn-mencion-ig"
                      href={m.instagramUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label={`Instagram de ${m.nombre}`}
                      data-testid={`qn-enlace-instagram-${i}`}
                    >
                      <Instagram strokeWidth={1.5} />
                    </a>
                  )}
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
